export function IPDSChart() {
  return (
    <div className="space-y-6">
      {/* Explainer */}
      <div className="bg-slate-900 border border-slate-800 rounded-xl p-6 shadow-sm">
        <h3 className="text-base font-semibold text-slate-200 mb-2 flex items-center gap-2">
          <span className="text-xl">📐</span> What is IPDS?
        </h3>
        <p className="text-slate-400 text-sm leading-relaxed mb-3">
          <strong className="text-slate-300">Incremental Profit per Dollar Spent (IPDS)</strong> measures the marginal return
          on each additional dollar you invest in advertising. Unlike total ROAS, IPDS captures the <em>diminishing returns</em> that
          occur as you scale — the first $1,000 in spend generates high-quality leads, but the next $5,000 reaches progressively
          less-intent audiences.
        </p>
        <p className="text-slate-400 text-sm leading-relaxed">
          The chart shows your estimated marginal ROAS curve. Spending beyond where the curve crosses your target ROAS
          threshold destroys value. The optimal budget is where marginal ROAS equals your minimum acceptable return.
        </p>
      </div>

      {/* Coming soon */}
      <div className="bg-slate-900 border border-slate-800 rounded-xl p-10 shadow-sm flex flex-col items-center justify-center gap-3">
        <div className="w-12 h-12 rounded-full bg-blue-600/15 flex items-center justify-center">
          <svg className="w-6 h-6 text-blue-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
          </svg>
        </div>
        <h4 className="text-slate-200 font-semibold text-sm">Marginal ROAS Curve — Coming Soon</h4>
        <p className="text-slate-500 text-xs text-center max-w-sm">
          This chart will plot your incremental ROAS against cumulative spend, helping you identify the optimal budget ceiling.
          Requires at least 30 days of campaign data with sufficient spend variation.
        </p>
      </div>
    </div>
  );
}
